import {lazy, useState} from 'react'

import PropTypes from 'prop-types'

import AtomSkeleton, {ATOM_SKELETON_VARIANTS} from '@s-ui/react-atom-skeleton'
import {useSuiContext} from '@s-ui/react-context'
import ScriptLoader from '@s-ui/react-script-loader'

const getGooglePlaces = () => Boolean(window?.google?.maps?.importLibrary)

const LazyFormLocationAutosuggest = lazy(() =>
  import(/* webpackChunkName: "LazyFormLocationAutosuggest" */ '../Autosuggest/index.js')
)

const FormLocationAutosuggestLoader = ({autoFocus, isLoading, onChange, value}) => {
  const [isGooglePlacesLoaded, setIsGooglePlacesLoaded] = useState(false)

  const {domain} = useSuiContext()

  const config = domain.get('config')

  const googleMapsApiKey = config.get('GOOGLE_MAPS_API_KEY')

  const GOOGLE_PLACES_SCRIPT = `https://maps.googleapis.com/maps/api/js?key=${googleMapsApiKey}&v=beta`

  const handleLoad = () => {
    setIsGooglePlacesLoaded(true)
  }

  return (
    <>
      <ScriptLoader isAsync render={handleLoad} src={GOOGLE_PLACES_SCRIPT} verifier={getGooglePlaces} />
      {isGooglePlacesLoaded ? (
        <LazyFormLocationAutosuggest autoFocus={autoFocus} isLoading={isLoading} onChange={onChange} value={value} />
      ) : (
        <AtomSkeleton variant={ATOM_SKELETON_VARIANTS.round} height={40} />
      )}
    </>
  )
}

FormLocationAutosuggestLoader.displayName = 'FormLocationAutosuggestLoader'
FormLocationAutosuggestLoader.propTypes = {
  autoFocus: PropTypes.bool,
  isLoading: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.arrayOf(PropTypes.number)
}

export default FormLocationAutosuggestLoader
